import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';

@Component({
  selector: 'app-equifax-detail-card',
  templateUrl: './equifax-detail-card.component.html',
  styleUrls: ['./equifax-detail-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,   
    MatCard
  ]
})
export class EquifaxDetailCardComponent {

  @Input() data!: DetailPair[];
  @Input() guest!: any;
  @Input() title!: string;
  @Input() trustDecision!: string;

  constructor() { }

  getColor(result?: any) {
    switch (result) {
      case 'Y': 
        return 'green';
      case 'Approve': 
        return 'green';
      case 'N': 
        return 'red';
      case 'Deny': 
        return 'red';
      default: 
        return 'white';
    }
  }

  getDecisionColor(result?: any) {
    switch (result) {
      case 'Y': 
        return 'background-green';
      case 'Approve': 
        return 'background-green';
      case 'N': 
        return 'background-red';
      case 'Deny': 
        return 'background-red';
      default: 
        return 'white';
    }
  }

  getTextFromValue(value: any) {
    switch (value) {
      case 'Y': 
        return 'Approve';
      case 'N': 
        return 'Deny';
      default: 
        return 'Considering';
    }
  }

}